import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import UserName from '~/components/Client/UserName';
import { DateText } from '~/eds/src/components/DateText/DateText';
import { Text } from '~/eds/src/components/Text/Text';
import { EntityType } from '~/enums/EntityType';
import { TicketActivityType } from '~/enums/TicketActivityType';
import { FormattedMessage } from 'react-intl';
import { api } from '~/redux/api/createApi';
import Alert from '~/ui/components/Alert/Alert';

const TicketCancelledWarning = ({ ticketId, cancelledDate }) => {
  const { data: activities = [] } = api.endpoints.getActivities.useQuery(
    {
      entityId: ticketId,
      entityType: EntityType.Ticket,
    },
    { skip: !ticketId },
  );

  const cancelledTicketActivity = useMemo(
    () =>
      activities.find(
        (activity) => activity.action === TicketActivityType.CancelTicket,
      ),
    [activities],
  );

  return cancelledTicketActivity ? (
    <Alert variant="warning">
      <Text variant="body-medium">
        <FormattedMessage
          id="TicketCancelledWarning.cancelledMessage"
          defaultMessage="Ticket was cancelled on {date} by {userName}."
          description="Message showing when ticket was cancelled and by whom, date is formatted as full datetime, username is the name of the user who cancelled the ticket."
          values={{
            date: (
              <DateText
                variant="body-medium"
                date={cancelledDate ? new Date(cancelledDate) : undefined}
                format="full_datetime"
              />
            ),
            userName: <UserName userId={cancelledTicketActivity.user.id} />,
          }}
        />
      </Text>
    </Alert>
  ) : null;
};

const mapStateToProps = ({ ticket }) => ({
  ticketId: ticket?.id,
  cancelledDate: ticket?.cancelledDate,
});
export default connect(mapStateToProps)(TicketCancelledWarning);
